import { Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { PriceProviderService } from 'src/app/services/price-provider.service';
import calculateBaseOdds from 'src/app/utils/pity-odds-calculator';

Chart.register(...registerables);

@Component({
  selector: 'two-handed-weapon-piercing-root',
  templateUrl: './two-handed-weapon-piercing.component.html',
  styleUrls: ['../../shared-scss/default.scss'],
  standalone: false,
})
export class TwoHandedWeaponPiercingComponent implements OnInit {
  constructor(
    private readonly gaService: GoogleAnalyticsService,
    readonly priceProvider: PriceProviderService
  ) {}

  ngOnInit(): void {
    this.SimulateUpgrading(false);
  }
  title = 'flyff-upgrade-calculator';

  simulationCount = 10000;

  gProsUsed: number[] = [0, 0, 0, 0, 0];
  pd8Used: number[] = [0, 0, 0, 0, 0];

  customUpgradeBonus = 0;
  getModifier() {
    let bonus = this.customUpgradeBonus;
    if (this.priceProvider.isFwc) {
      bonus += 100;
    }
    return 1 + bonus / 100;
  }
  isPd10 = false;
  isPiercingEvent = false;
  currentAttemptsIn = 0;
  currentPierce = 0;
  targetPierce = 10;

  baseOdds = [50, 50, 25, 25, 12.5, 12.5, 6.25, 6.25, 3.13, 3.13];
  basePd10Odds = [55, 55, 27.5, 27.5, 15, 15, 7.5, 7.5, 3.8, 3.8];
  basePiercingEventOdds = [52.5, 52.5, 26.3, 26.3, 13.8, 13.8, 6.9, 6.9, 3.4, 3.4];
  basePiercingEventPd10Odds = [
    57.8, 57.8, 28.9, 28.9, 16.5, 16.5, 8.3, 8.3, 4.1, 4.1,
  ];

  odds = this.baseOdds.map((x) => x * this.getModifier());
  piercingEventOdds = this.basePiercingEventOdds.map((x) => x * this.getModifier())
  pd10Odds = this.basePd10Odds.map((x) => x * this.getModifier());
  piercingEventPd10Odds = this.basePiercingEventPd10Odds.map((x) => x * this.getModifier());

  pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEvent = this.basePiercingEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsPd10 = this.basePd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
  pityOddsEventPd10 = this.basePiercingEventPd10Odds.map((x) =>
    calculateBaseOdds(x * this.getModifier())
  );

  myChart: Chart | undefined = undefined;

  GenerateChart() {
    if (this.myChart) {
      this.myChart.destroy();
    }

    const chartData: any = {
      labels: ['0 > 1', '1 > 2', '2 > 3', '3 > 4', '4 > 5', '5 > 6', '6 > 7', '7 > 8', '8 > 9', '9 > 10'],
      datasets: [
        {
          label: 'Attempts',
          data: this.gProsUsed.map((x) => x / this.simulationCount),
          borderWidth: 1,
        },
      ],
    };

    const config: any = {
      type: 'bar',
      data: chartData,
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    };

    const chartElem = <HTMLCanvasElement>(
      document.getElementById(`upgrade-data-chart`)
    );

    this.myChart = new Chart(chartElem, config);
  }

  SimulateUpgrading(isUserInput = true) {
    if (!this.verifyInput()) {
      return;
    }

    if (isUserInput) {
      this.gaService.event(
        'simulate_two_handed_pierce',
        'simulate',
        'Simulate two handed weapon pierce',
        this.simulationCount,
        true
      );
    }

    // Reset starter values
    this.gProsUsed = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.pd8Used = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // Calculate odds with upgrade bonus
    this.odds = this.baseOdds.map((x) => x * this.getModifier());
    this.piercingEventOdds = this.basePiercingEventOdds.map((x) => x * this.getModifier())
    this.pd10Odds = this.basePd10Odds.map((x) => x * this.getModifier());
    this.piercingEventPd10Odds = this.basePiercingEventPd10Odds.map((x) => x * this.getModifier());

    this.pityOdds = this.baseOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEvent = this.basePiercingEventOdds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsPd10 = this.basePd10Odds.map((x) => calculateBaseOdds(x * this.getModifier()));
    this.pityOddsEventPd10 = this.basePiercingEventPd10Odds.map((x) =>
      calculateBaseOdds(x * this.getModifier())
    );

    // Start upgrading
    for (let i = 0; i < this.simulationCount; i++) {
      let currentUpgrade = this.currentPierce;

      while (currentUpgrade < this.targetPierce) {
        let failedTries = 0;
        if (currentUpgrade === this.currentPierce) {
          failedTries = this.currentAttemptsIn;
        }
        let isSuccessful = false;
        while (!isSuccessful) {
          isSuccessful = this.SimulateSingleUpgrade(
            currentUpgrade,
            failedTries
          );
          if (!isSuccessful) {
            failedTries++;
          }
        }
        currentUpgrade++;
      }
    }

    this.GenerateChart();
  }

  verifyInput() {
    // clear all red inputs
    let isValid = true;
    if (this.currentPierce < 0 || this.currentPierce > 9) {
      // make input red
      isValid = false;
    }
    if (this.targetPierce < 1 || this.targetPierce > 10) {
      // make input red
      isValid = false;
    }
    if (this.currentAttemptsIn < 0) {
      // make input red
      isValid = false;
    }
    if (this.currentPierce >= this.targetPierce) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.gProPrice < 0) {
      // make input red
      isValid = false;
    }
    if (this.priceProvider.pd8Price < 0) {
      // make input red
      isValid = false;
    }
    return isValid;
  }

  addUpgradeTry(currentUpgrade: number) {
    this.gProsUsed[currentUpgrade]++;
    this.pd8Used[currentUpgrade]++;
  }

  SimulateSingleUpgrade(currentUpgrade: number, failedTries: number): boolean {
    this.addUpgradeTry(currentUpgrade);
    const random = Math.random() * 100;
    let odds = this.GetPiercingOdds()[currentUpgrade] * (failedTries + 1);

    if (random < odds) {
      return true;
    }
    return false;
  }

  GetGprosUsed(): number {
    return this.gProsUsed.reduce((a, b) => a + b, 0);
  }

  GetPd8Used(): number {
    return this.pd8Used.reduce((a, b) => a + b, 0);
  }

  GetTotalPenyaCost(): number {
    const totalXproCost = this.GetPd8Used() * this.priceProvider.gProPrice;
    const totalSunstoneCost = this.GetPd8Used() * this.priceProvider.pd8Price;
    return totalXproCost + totalSunstoneCost;
  }

  GetPiercingOdds(): number[] {
    const isPity = true;
    type OddsKey = 'default' | 'piercingEvent' | 'pd10' | 'piercingEventPd10';

    const baseOdds: Record<OddsKey, number[]> = {
      default: this.odds,
      piercingEvent: this.piercingEventOdds,
      pd10: this.pd10Odds,
      piercingEventPd10: this.piercingEventPd10Odds,
    };

    const pityOdds: Record<OddsKey, number[]> = {
      default: this.pityOdds,
      piercingEvent: this.pityOddsEvent,
      pd10: this.pityOddsPd10,
      piercingEventPd10: this.pityOddsEventPd10,
    };

    let key: OddsKey = 'default';
    if (this.isPd10 && this.isPiercingEvent) key = 'piercingEventPd10';
    else if (this.isPiercingEvent) key = 'piercingEvent';
    else if (this.isPd10) key = 'pd10';

    let odds;
    if (isPity) {
      odds = pityOdds[key];
    } else {
      odds = baseOdds[key];
    }
    return odds;
  }
}
